module.exports = __webpack_public_path__ + "media/images/countrysquared/pg-c1cdd61d025e9db27d6345480b50dfd3.svg";